import React from "react"
import usePromise from "./usePromise"
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Typography } from "@mui/material"
import { ErrorOutline, HelpOutline } from "@mui/icons-material"

export default function useConfirm() {
  // States
  const [open, setOpen] = React.useState(false)
  const [resolver, setResolver] = React.useState({ resolver: null })
  const [title, setTitle] = React.useState("")
  const [text, setText] = React.useState("")
  const [confirmText, setConfirmText] = React.useState("Confirm")
  const [cancelText, setCancelText] = React.useState("Cancel")
  const [important, setImportant] = React.useState(false)

  // Functions
  async function getConfirmation(title, text, important = true, confirmText = "Confirm", cancelText = "Cancel") {
    setTitle(title)
    setText(text)
    setConfirmText(confirmText)
    setCancelText(cancelText)
    setImportant(important)
    setOpen(true)
    const [promise, resolve] = await usePromise()
    setResolver({ resolve })
    return promise
  }

  async function onClick(status) {
    setOpen(false)
    resolver.resolve(status)
  }

  function Confirmation() {
    return (
      <Dialog open={open} maxWidth="xs">
        <DialogTitle variant="h5" align="center">
          {important && <ErrorOutline color="error" sx={{ fontSize: 100 }} />}
          {!important && <HelpOutline color="primary" sx={{ fontSize: 100 }} />}
        </DialogTitle>
        <DialogContent>
          <Grid container>
            <Grid size={12}>
              <Typography variant="h4" align="center">
                {title}
              </Typography>
            </Grid>
            <Grid size={12}>
              <Typography display="block" component="span" align="center">
                {text}
              </Typography>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button color="error" onClick={() => onClick(false)}>{cancelText}</Button>
          <Button color="success" onClick={() => onClick(true)}>{confirmText}</Button>
        </DialogActions>
      </Dialog>
    )
  }

  return [getConfirmation, Confirmation]
}